(function () {
  var doc = document, root = doc.documentElement;
  var shell = doc.getElementById('vk-shell');
  var KEY = 'vk_welkom', SKEY = 'vk_snd';
  function $(id) { return doc.getElementById(id); }
  function vib(ms) { try { navigator.vibrate && navigator.vibrate(ms); } catch (e) {} }

  /* ---------- tabtitel: Samen sterker / Laten we ons land bouwen / paginatitel ---------- */
  var original = doc.title;
  var frames = ['SAMEN STERKER 🦁', 'LATEN WE ONS LAND BOUWEN', original];
  var fi = 2;
  if (!root.classList.contains('shopify-design-mode')) {
    setInterval(function () { fi = (fi + 1) % frames.length; doc.title = frames[fi]; }, 1500);
  }

  /* ---------- onderste tabbalk: actieve tab ---------- */
  var tabs = $('vk-tabs');
  if (tabs) {
    doc.body.classList.add('vk-has-tabs');
    var path = location.pathname.replace(/\/$/, '') || '/';
    var best = null;
    Array.prototype.forEach.call(tabs.querySelectorAll('a'), function (a) {
      var p = (a.getAttribute('href') || '').replace(/\/$/, '') || '/';
      if (p === path || (p !== '/' && path.indexOf(p) === 0)) best = a;
    });
    if (best) best.classList.add('vk-on');
  }

  if (!shell) return;
  var gate = $('vk-gate'), bar = $('vk-anthem');
  var isHome = shell.getAttribute('data-home') === '1';
  if (!isHome || !bar) return;

  /* Alleen de eerste keer: de vraag en het volkslied verschijnen enkel voor een bezoeker die nog nooit binnenkwam.
     Wie al 'Ja' koos (opgeslagen als vk_welkom) ziet geen vraag, geen volkslied en geen balk meer. */
  if (!root.classList.contains('vk-gate-on')) return;

  /* ---------- volkslied (vastgepind, wordt nooit onderbroken) ---------- */
  var SND = { be: shell.getAttribute('data-be'), fl: shell.getAttribute('data-fl') };
  var TITLES = { be: 'La Brabançonne · volkslied van België', fl: 'De Vlaamse Leeuw · Vlaams volkslied' };
  var pref = 'be';
  try { pref = localStorage.getItem(SKEY) || 'be'; } catch (e) {}
  var au = new Audio(); au.volume = 0.55;
  var started = false, blocked = '';

  function showBar() { bar.hidden = false; doc.body.classList.add('vk-has-anthem'); }
  function label() {
    var k = pref === 'off' ? 'be' : pref;
    $('vk-atx').textContent = au.ended ? 'Volkslied afgelopen' : (started ? TITLES[k] : (blocked ? 'Geluid geblokkeerd door je browser: tik op ▶ (' + blocked + ')' : 'Luister naar het volkslied · ' + TITLES[k]));
  }
  function btn() { $('vk-abtn').textContent = au.ended ? '↻ Opnieuw' : (!started ? '▶ Afspelen' : (au.muted ? '🔇' : '🔊')); }
  function start() {
    var k = pref === 'off' ? 'be' : pref;
    au.src = SND[k]; au.muted = false;
    var p = au.play();
    if (p && p.then) {
      p.then(function () { started = true; blocked = ''; label(); btn(); })
       .catch(function (e) { started = false; blocked = e.name; label(); btn(); });
    }
  }
  function playAnthem() { showBar(); if (pref === 'off') { label(); btn(); } else start(); }
  au.addEventListener('timeupdate', function () { if (au.duration) $('vk-aprog').style.width = (au.currentTime / au.duration * 100) + '%'; });
  au.addEventListener('ended', function () { label(); btn(); });
  /* de knop dempt alleen het geluid: het volkslied loopt door en wordt nooit gepauzeerd of afgebroken */
  $('vk-abtn').addEventListener('click', function () {
    if (!started || au.ended) start(); else { au.muted = !au.muted; btn(); }
  });
  ['pointerdown', 'keydown', 'touchend'].forEach(function (ev) {
    doc.addEventListener(ev, function () {
      if (!started && !bar.hidden && pref !== 'off' && !au.ended && !root.classList.contains('vk-gate-on')) start();
    }, true);
  });

  /* ---------- poort ---------- */
  var n = 0, pass = false;
  var optBtns = doc.querySelectorAll('.vk-snd-opts button');
  Array.prototype.forEach.call(optBtns, function (b) {
    b.classList.toggle('vk-on', b.getAttribute('data-s') === pref);
    b.addEventListener('click', function () {
      pref = b.getAttribute('data-s');
      try { localStorage.setItem(SKEY, pref); } catch (e) {}
      Array.prototype.forEach.call(optBtns, function (x) { x.classList.toggle('vk-on', x === b); });
    });
  });

  function enter(confetti, el) {
    if (confetti && el) {
      var r = el.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      ['#f5c518', '#c8102e', '#fff', '#f5c518', '#000'].forEach(function (c) {
        for (var k = 0; k < 9; k++) {
          var d = doc.createElement('div'); d.className = 'vk-burst';
          d.style.cssText = 'background:' + c + ';left:' + cx + 'px;top:' + cy + 'px';
          doc.body.appendChild(d);
          var a = Math.random() * Math.PI * 2, v = 110 + Math.random() * 200;
          if (d.animate) {
            d.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + Math.cos(a) * v + 'px,' + Math.sin(a) * v + 'px) scale(.2)', opacity: 0 }], { duration: 900, easing: 'cubic-bezier(.2,.8,.2,1)' });
          }
          (function (node) { setTimeout(function () { node.remove(); }, 950); })(d);
        }
      });
    }
    vib(40); playAnthem();
    try { localStorage.setItem(KEY, '1'); } catch (e) {}
    setTimeout(function () { gate.classList.add('vk-open'); root.classList.remove('vk-gate-on'); }, 300);
    setTimeout(function () { gate.style.display = 'none'; }, 1300);
  }
  $('vk-yes').addEventListener('click', function (e) { enter(true, e.currentTarget); });
  $('vk-no').addEventListener('click', function (e) {
    if (pass) return enter(false, e.currentTarget);
    var box = $('vk-nope'); n++;
    box.classList.remove('vk-shake'); void box.offsetWidth; box.classList.add('vk-show', 'vk-shake'); vib([30, 40, 30]);
    var emo = box.querySelector('.vk-emo'), msg = box.querySelector('.vk-msg');
    var emojis = ['🤨', '😬'], msgs = ['Ongeldig antwoord', 'Hmm… nee, dat klopt niet'];
    if (n >= 3) {
      pass = true; box.classList.add('vk-ok'); emo.textContent = '😄'; msg.textContent = 'Ok, ok… vooruit dan, kom binnen 😄';
      e.currentTarget.textContent = 'Vooruit dan, binnen →'; e.currentTarget.classList.add('vk-pass');
    } else { emo.textContent = emojis[n - 1]; msg.textContent = msgs[n - 1]; }
  });
})();
